// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/transportation/reports/freshwater.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { EmptyRequest } from "../../../common/messages/messages";
import {
  FreshwaterDeliveryNote,
  GetFreshWaterDeliveryNoteRequest,
  GetFreshwaterRequest,
  GetFreshwatersResponse,
  GetOneFreshwaterResponse,
  GetUpdatedFreswatersRequest,
  UpdateFreshwaterRequest,
} from "./freshwater";

import { FreshwaterServiceClientImpl } from "./freshwater";

@Injectable({ providedIn: "root" })
export class FreshwaterServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  async addFreshwaterDeliveryNote(request: FreshwaterDeliveryNote): Promise<GetOneFreshwaterResponse> {
    const client = new FreshwaterServiceClientImpl(this._rpc);
    return await client.addFreshwaterDeliveryNote(request);
  }
  async updateFreshwaterDeliveryNote(request: UpdateFreshwaterRequest): Promise<GetOneFreshwaterResponse> {
    const client = new FreshwaterServiceClientImpl(this._rpc);
    return await client.updateFreshwaterDeliveryNote(request);
  }
  async getOneFreshWaterDeliveryNote(request: GetFreshWaterDeliveryNoteRequest): Promise<GetOneFreshwaterResponse> {
    const client = new FreshwaterServiceClientImpl(this._rpc);
    return await client.getOneFreshWaterDeliveryNote(request);
  }
  async getFreshwaters(request: GetFreshwaterRequest): Promise<GetFreshwatersResponse> {
    const client = new FreshwaterServiceClientImpl(this._rpc);
    return await client.getFreshwaters(request);
  }
  async getUpdatedFreshwaters(request: GetUpdatedFreswatersRequest): Promise<GetFreshwatersResponse> {
    const client = new FreshwaterServiceClientImpl(this._rpc);
    return await client.getUpdatedFreshwaters(request);
  }
  async getAllFreshwaters(request: EmptyRequest): Promise<GetFreshwatersResponse> {
    const client = new FreshwaterServiceClientImpl(this._rpc);
    return await client.getAllFreshwaters(request);
  }
}
